try {
  if (window) module.exports = require('@oddbird/popover-polyfill');
} catch (ex) {
  module.exports = () => {};
}
